import { render, staticRenderFns } from "./dataprocess-form1.vue?vue&type=template&id=3f48bd5d&scoped=true&"
import script from "./dataprocess-form1.vue?vue&type=script&lang=ts&"
export * from "./dataprocess-form1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f48bd5d",
  null
  
)

export default component.exports